"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsConfiguration_1 = require("./_AnalyticsConfiguration");
exports.GetBucketAnalyticsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {
        AnalyticsConfiguration: {
            shape: _AnalyticsConfiguration_1._AnalyticsConfiguration
        }
    },
    payload: "AnalyticsConfiguration"
};
//# sourceMappingURL=GetBucketAnalyticsConfigurationOutput.js.map